import { CommonModule } from "@angular/common";
import {
	ChangeDetectorRef,
	Component,
	Input,
	OnChanges,
} from "@angular/core";

import { CountryService } from "src/app/_core/services/country.service";

/**
 * Muestra un país en modo lectura: bandera pequeña (SVG, flag-icons servido en assets/flags)
 * + nombre, en línea, sin aumentar la altura de fila. Reutilizable en toda la app.
 * Acepta el ISO2 directo, el id de país o solo el nombre (resuelve vía CountryService).
 */
@Component({
	selector: "app-country",
	templateUrl: "./country.component.html",
	styleUrls: ["./country.component.scss"],
	standalone: true,
	imports: [CommonModule],
})
export class CountryComponent implements OnChanges {
	@Input() name?: string | null;
	@Input() iso2?: string | null;
	/** Id interno del país (FK del backend) → se mapea a ISO2 vía el maestro. */
	@Input() paisId?: number | null;
	/** Texto cuando no hay país. */
	@Input() empty = "—";

	iso2Resolved: string | null = null;
	flagError = false;

	constructor(
		private readonly countryService: CountryService,
		private readonly cdr: ChangeDetectorRef,
	) {}

	ngOnChanges(): void {
		this.flagError = false;
		this.countryService
			.resolveIso2({ iso2: this.iso2, paisId: this.paisId, name: this.name })
			.subscribe((iso) => {
				this.iso2Resolved = iso;
				// El maestro puede resolverse async tras el primer render; en padres
				// OnPush hay que marcar para que la bandera se pinte sin interacción.
				this.cdr.markForCheck();
			});
	}

	get hasName(): boolean {
		return !!this.name && this.name.trim().length > 0;
	}

	get flagSrc(): string {
		return `assets/flags/${this.iso2Resolved}.svg`;
	}
}
